import React from "react";
import { Missing } from "components/Shared";

export default () => <Missing />;
